import {
  FETCH_PRODUCTOS_REQUEST,
  FETCH_PRODUCTOS_SUCCESS,
  FETCH_PRODUCTOS_FAILURE,
} from "../actions/productos/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTOS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PRODUCTOS_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_PRODUCTOS_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
